import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';
import { FiltersService } from 'src/app/services/filters.service';

@Component({
  selector: 'app-evaluations',
  templateUrl: './evaluation.component.html',
  styleUrls: ['./evaluation.component.css']
})
export class EvaluationComponent implements OnInit, OnDestroy {
  packageID;
  roleId;
  subscription: Subscription;
  subscriptionUser: Subscription;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  
  constructor(
    public appConfig: AppConfig,
    public layoutService: PHBHPLayoutPackageService,
    private filtersService: FiltersService
  ) { }

  ngOnInit() {
    this.packageID = this.layoutService.packageID;
    this.filtersService.loadFilters();
    this.subscription = this.layoutService.packageIDSubject.asObservable().subscribe((res) => {
      this.packageID = this.layoutService.packageID;
    });
    if (this.appConfig.userData) {
      this.roleId = this.appConfig.userData.roleName.roleId;
    } else {
      this.subscriptionUser = this.appConfig.userSubject.asObservable().subscribe(res => {
        this.roleId = this.appConfig.userData.roleName.roleId;
      })
    }
    
  }
  onChildData(event: any) {
    //this.router.navigate([event]);
  }
  ngOnDestroy(){
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.subscriptionUser){
      this.subscriptionUser.unsubscribe();
    }
  }

  isMyHygieneSOPLicense(packageID) {
    return packageID == 1 || packageID == 3 || packageID == 5 || packageID == 7;
  }

  isObserveLicense(packageID) {
    return packageID == 2 || packageID == 3 || packageID == 6 || packageID == 7;
  }

  isHygieneCheckLicense(packageID) {
    return packageID == 4 || packageID == 5 || packageID == 6 || packageID == 7;
  }
}
